module.exports = __webpack_public_path__ + "img/inst-2.17e51c85.png";